


















































import CoLoadingIndicator from '../../Atoms/co-loading-indicator/coLoadingIndicator.vue';
import CoText from '../../Atoms/co-text/CoText.vue';
import CoAlert from '../co-alert/CoAlert.vue';

export default {
    name: 'CoHumanVerification',
    components: {
        CoAlert,
        CoLoadingIndicator,
        CoText,
    },
    props: {
        challengeUrl: {
            type: String,
            default: 'https://api.coapp.io/v1/captcha-challenge',
        },
        timeoutMs: {
            type: Number,
            default: 5000,
        },
    },
    data() {
        return {
            captchaKey: 0,
            state: 'verifying',
        };
    },
    computed: {
        captchaError() {
            return this.state === 'error';
        },
        statusText() {
            if (this.captchaError) {
                return this.$t('messages.humanVerificationError');
            }
            if (this.verified) {
                return this.$t('messages.captchaReady');
            }
            return this.$t('messages.captchaWorking');
        },
        verified() {
            return this.state === 'verified';
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.initAltcha();
        });
    },
    beforeDestroy() {
        this.detachAltchaListener();
    },
    methods: {
        detachAltchaListener() {
            const altchaEl = this.$refs.altchaWidget;
            if (altchaEl && this.onAltchaStateChange) {
                altchaEl.removeEventListener('statechange', this.onAltchaStateChange);
            }
        },
        async waitForAltchaElement() {
            if (!window.customElements || typeof window.customElements.whenDefined !== 'function') {
                return;
            }

            await Promise.race([
                window.customElements.whenDefined('altcha-widget'),
                new Promise((resolve, reject) => {
                    window.setTimeout(
                        () => reject(new Error('ALTCHA custom element did not load in time')),
                        this.timeoutMs
                    );
                }),
            ]);
        },
        async initAltcha() {
            const altchaEl = this.$refs.altchaWidget;
            if (!altchaEl) {
                this.setError();
                return;
            }

            try {
                // ALTCHA is loaded asynchronously from index.html; wait for the custom element before configuring it.
                await this.waitForAltchaElement();
            } catch (error) {
                this.setError();
                return;
            }

            if (typeof altchaEl.configure !== 'function' || typeof altchaEl.verify !== 'function') {
                this.setError();
                return;
            }

            this.detachAltchaListener();
            altchaEl.addEventListener('statechange', this.onAltchaStateChange);
            try {
                this.setState('verifying');
                altchaEl.configure({ auto: 'off', delay: 300 });
                const verification = altchaEl.verify();
                if (verification && typeof verification.catch === 'function') {
                    verification.catch(() => this.setError());
                }
            } catch (error) {
                this.setError();
            }
        },
        onAltchaStateChange(ev) {
            if (ev.detail.state === 'verified') {
                this.setState('verified', ev.detail.payload);
                return;
            }

            if (ev.detail.state === 'error') {
                this.setError();
                return;
            }

            this.setState(ev.detail.state);
        },
        reset() {
            this.detachAltchaListener();
            this.captchaKey += 1;
            this.setState('verifying');

            this.$nextTick(() => {
                this.initAltcha();
            });
        },
        setState(state, payload = '') {
            this.state = state;
            this.$emit('status', {
                payload,
                state,
                verified: state === 'verified',
            });
        },
        setError() {
            this.setState('error');
        },
    },
};
